import { Suspense } from 'react'
import { Outlet } from 'react-router'

import { SxProps } from '@mui/material'
import Box from '@mui/material/Box'
import { Footer, Header } from 'components'
import { Loading } from 'components/ui'

type Props = {
  sx?: SxProps
}

function BaseLayout({ sx }: Props) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        ...sx
      }}
    >
      <Header />
      <Box component='main' sx={{ flexGrow: 1 }}>
        <Suspense fallback={<Loading fullScreen />}>
          <Outlet />
        </Suspense>
      </Box>
      <Footer />
    </Box>
  )
}

export default BaseLayout
